import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';

import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatOptionModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { Reprise } from 'src/app/domain/Qualif/reprise';
import { PreventDoubleClickDirective } from '../../directive/prevent-double-click.directive';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-reprise-box',
    templateUrl: './reprise-box.html',
    styleUrl: './reprise-box.scss',
    standalone: true,
    imports: [CommonModule, MatDialogModule, MatFormFieldModule, MatSelectModule, FormsModule, MatOptionModule, MatInputModule, MatDatepickerModule, MatButtonModule, PreventDoubleClickDirective]
})
export class RepriseBoxDialog implements OnInit {

    public Model: Reprise = new Reprise();

    constructor(
        public dialogRef: MatDialogRef<RepriseBoxDialog>,
        @Inject(MAT_DIALOG_DATA) public data: any) {
        if (data.reprise)
            this.Model = data.reprise;
        else {

            if (data.lastLongueur)
                this.Model.Longueur = data.lastLongueur

            if (data.lastLargeur)
                this.Model.Largeur = data.lastLargeur
        }

        this.updateSurface()
    }

    ngOnInit() { }

    updateSurface() {
        if (!this.Model.Largeur || !this.Model.Longueur)
            return;
        this.Model.Surface = Number((this.Model.Largeur * this.Model.Longueur).toFixed(5))
    }

    canSave() {
        return this.Model.Longueur && this.Model.Largeur && this.Model.Surface &&
            this.Model.Longueur > 0 && this.Model.Largeur > 0 && this.Model.Surface > 0
    }

    onCancel(): void {
        this.dialogRef.close();
    }

    onConfirm() {
        this.dialogRef.close(this.Model);
    }
}
